module.exports = __webpack_public_path__ + "static/media/s6.61fe4804.jpg";